import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import * as Actions from '../Actions';
import { basicOrderInfoQueryKey, suspenseSafeCacheTime } from './useBasicOrderInfoData';

export function useBasicOrderInfoSuspense(orderId: number): void {
    const dispatch = useDispatch<any>();

    useQuery([basicOrderInfoQueryKey, orderId], () => dispatch(Actions.view(orderId)), {
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        cacheTime: suspenseSafeCacheTime,
        suspense: true,
        useErrorBoundary: false
    });
}
